import React from 'react';
import Box from '@mui/material/Box';

const scaleMap = {
  xs: 0.5,
  s: 1,
  m: 2,
  l: 3,
  xl: 4,
} as const;

const alignItemsMap = {
  stretch: 'stretch',
  flexStart: 'flex-start',
  flexEnd: 'flex-end',
  center: 'center',
} as const;

const justifyContentMap = {
  normal: 'normal',
  stretch: 'stretch',
  flexStart: 'flex-start',
  flexEnd: 'flex-end',
  center: 'center',
} as const;

type InlineProps = {
  children: React.ReactNode;
  scale?: 'xs' | 's' | 'm' | 'l' | 'xl';
  className?: string;
  alignItems?: 'stretch' | 'flexStart' | 'flexEnd' | 'center';
  justifyContent?: 'normal' | 'stretch' | 'flexStart' | 'flexEnd' | 'center';
  style?: React.CSSProperties;
};

const Inline = ({
  children,
  scale = 's',
  alignItems = 'flexStart',
  justifyContent = 'normal',
  className,
  style,
}: InlineProps) => (
  <Box
    className={className}
    sx={{
      display: 'flex',
      flexDirection: 'row',
      gap: scaleMap[scale],
      alignItems: alignItemsMap[alignItems],
      justifyContent: justifyContentMap[justifyContent],
      ...style,
    }}
  >
    {children}
  </Box>
);

export default Inline;
